/* Joyeux Marché — magie de Noël (26/10, corrigé le 30/10). Sans dépendance, respecte « animations réduites ».
   Horizon fait défiler la page dans .page-wrapper (et non dans la fenêtre) : le retour en haut et la barre de lecture
   lisent donc le défilement de ce conteneur. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var fine = window.matchMedia ? matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  function reduced() { return mq.matches || root.classList.contains('jm-reduced'); }
  var main = d.getElementById('MainContent');
  var tpl = main ? main.getAttribute('data-template') || '' : '';
  if (/^product/.test(tpl)) root.classList.add('jm-pdp');

  /* Horizon fait défiler .page-wrapper sur ordinateur (dès 990 px) et la fenêtre sur mobile : on écoute les deux */
  var PW = null;
  function scrollTop() { return Math.max(window.scrollY || 0, PW ? PW.scrollTop : 0); }
  function onScroll(fn) {
    window.addEventListener('scroll', fn, { passive: true });
    if (PW) PW.addEventListener('scroll', fn, { passive: true });
  }

  /* 1. Retour en haut en étoile */
  function topButton() {
    var b = d.createElement('button');
    b.type = 'button'; b.className = 'jm-top'; b.setAttribute('aria-label', 'Remonter en haut de la page');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2.5l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 16.5l-5.4 2.9 1-6.1L3.2 9l6.1-.9z"/></svg>';
    d.body.appendChild(b);
    var on = false, ticking = false;
    function check() {
      ticking = false;
      var show = scrollTop() > innerHeight * 1.5;
      if (show !== on) { on = show; b.classList.toggle('is-on', on); b.tabIndex = on ? 0 : -1; }
    }
    b.tabIndex = -1;
    onScroll(function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } });
    b.addEventListener('click', function (e) {
      if (!reduced()) { b.classList.remove('is-launch'); void b.offsetWidth; b.classList.add('is-launch'); setTimeout(function () { b.classList.remove('is-launch'); }, 750); }
      var opts = { top: 0, behavior: reduced() ? 'instant' : 'smooth' };
      if (PW && PW.scrollTop > 0) PW.scrollTo(opts); else window.scrollTo(opts);
      /* Au clavier, le focus repart du haut de la page (le bouton va disparaître) */
      if (e.detail === 0) {
        setTimeout(function () { var skip = d.querySelector('a[href="#MainContent"]'); if (skip) skip.focus({ preventScroll: true }); }, reduced() ? 0 : 600);
      }
    });
    check();
  }

  /* 2. Barre de lecture en guirlande (articles) */
  function readingBar() {
    if (!/^article/.test(tpl)) return;
    var bar = d.createElement('div'); bar.className = 'jm-read'; bar.setAttribute('aria-hidden', 'true');
    d.body.appendChild(bar);
    var art = d.querySelector('main article') || main, ticking = false;
    function upd() {
      ticking = false;
      var r = art.getBoundingClientRect(), total = r.height - innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
      bar.style.setProperty('--p', p.toFixed(3));
    }
    onScroll(function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } });
    addEventListener('resize', upd, { passive: true });
    upd();
  }

  /* 3. Poussière d'étoiles derrière la souris, sur le hero uniquement */
  function stardust() {
    var hero = d.querySelector('.jm-hero'); if (!hero || !fine.matches) return;
    var last = 0, live = 0, GL = ['✦', '✧', '⋆', '❄'];
    hero.addEventListener('pointermove', function (e) {
      if (reduced() || e.pointerType !== 'mouse') return;
      var now = performance.now(); if (now - last < 45 || live > 24) return; last = now;
      var s = d.createElement('span'); s.className = 'jm-dust'; s.setAttribute('aria-hidden', 'true');
      s.textContent = GL[(Math.random() * GL.length) | 0];
      s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px';
      s.style.setProperty('--x', (Math.random() * 40 - 20) + 'px');
      s.style.setProperty('--y', (12 + Math.random() * 30) + 'px');
      s.style.setProperty('--s', (9 + Math.random() * 8) + 'px');
      d.body.appendChild(s); live++;
      setTimeout(function () { s.remove(); live--; }, 950);
    });
  }

  /* 4. Étoiles filantes au crépuscule et la nuit, seulement quand le hero est visible */
  function shootingStars() {
    var hero = d.querySelector('.jm-hero'); if (!hero || !('IntersectionObserver' in window)) return;
    var scene = hero.querySelector('.jm-hero__scene'), visible = false, timer = 0;
    function night() { var s = hero.getAttribute('data-jm-sky'); return s === 'night' || s === 'dusk'; }
    function one() {
      if (visible && !d.hidden && !reduced() && night()) {
        var st = d.createElement('span'); st.className = 'jm-shoot'; st.setAttribute('aria-hidden', 'true');
        st.style.setProperty('--t', (6 + Math.random() * 26) + '%');
        st.style.setProperty('--l', (Math.random() * 55) + '%');
        hero.insertBefore(st, scene || null);
        setTimeout(function () { st.remove(); }, 1300);
      }
      timer = setTimeout(one, 6000 + Math.random() * 7000);
    }
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(hero);
    timer = setTimeout(one, 2500);
  }


  /* 5. « Tu as regardé récemment » : mémorisé dans le navigateur du visiteur uniquement */
  function lget(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } }
  function lset(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function recentlyViewed() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/), cur = m ? decodeURIComponent(m[1]) : null;
    var list = lget('jm_vus');
    if (cur) { list = [cur].concat(list.filter(function (h) { return h !== cur; })).slice(0, 12); lset('jm_vus', list); }
    var box = d.querySelector('[data-jm-vus]'); if (!box) return;
    var ul = box.querySelector('ul'), want = list.filter(function (h) { return h !== cur; }).slice(0, 6);
    if (want.length < 2) return;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
    Promise.all(want.map(function (h) {
      return fetch(base + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var ok = ps.filter(function (p) { return p && p.available; });
      if (ok.length < 2) return;
      ok.forEach(function (p) {
        var li = d.createElement('li'); li.className = 'jm-vus__item';
        var a = d.createElement('a'); a.className = 'jm-vus__link'; a.href = p.url;
        if (p.featured_image) {
          var img = d.createElement('img'); img.loading = 'lazy'; img.alt = ''; img.width = 300; img.height = 300;
          img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300';
          a.appendChild(img);
        }
        var t = d.createElement('span'); t.className = 'jm-vus__name'; t.textContent = p.title; a.appendChild(t);
        var pr = d.createElement('span'); pr.className = 'jm-vus__price';
        pr.textContent = (p.price_min !== p.price_max ? 'dès ' : '') + money(p.price_min); a.appendChild(pr);
        li.appendChild(a); ul.appendChild(li);
      });
      box.hidden = false;
    });
  }

  function init() { PW = d.querySelector('.page-wrapper'); topButton(); readingBar(); stardust(); shootingStars(); recentlyViewed(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
